import { render, staticRenderFns } from "./Secrets.vue?vue&type=template&id=32549dd6"
import script from "./Secrets.vue?vue&type=script&lang=ts"
export * from "./Secrets.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports